/**
 * Stable `data-onboarding` attribute values used as react-joyride step targets.
 *
 * The value is written onto a DOM element; `onboardingTargetSelector` builds the
 * matching CSS attribute selector that a tour step targets. Keeping both in one
 * place prevents the attribute and the selector from drifting apart.
 */
export const ONBOARDING_ANCHORS = {
  sidebarTabs: "ss-sidebar-tabs",
  planList: "ss-plan-list",
  viewer: "ss-viewer",
  headerActions: "ss-header-actions",
  rightTabs: "ss-right-tabs",
  searchInput: "ss-search-input",
  approvalBar: "ss-approval-bar",
  categoryList: "ss-category-list",
  categoryRowFirst: "ss-category-row-first",
  inspectorHeader: "ss-inspector-header",
  inspectorStartReviewButton: "ss-inspector-start-review-button",
  inspectorGroupName: "ss-inspector-group-name",
  elementDetails: "ss-element-details",
} as const;

export type OnboardingAnchor = keyof typeof ONBOARDING_ANCHORS;

export const onboardingTargetSelector = (anchor: OnboardingAnchor): string =>
  `[data-onboarding="${ONBOARDING_ANCHORS[anchor]}"]`;
